import { useState } from "react";
import { Info } from "lucide-react";

/** Small info icon: hover on desktop, tap on mobile. One or two plain sentences. */
export default function Tip({ text, label, className = "" }) {
  const [open, setOpen] = useState(false);
  return (
    <span className={`relative inline-flex items-center ${className}`}>
      <button
        type="button"
        data-testid={`tip-${(label || text || "").toString().slice(0, 24).replace(/\s+/g, "-").toLowerCase()}`}
        aria-label={label ? `About ${label}` : "More info"}
        onClick={(e) => { e.stopPropagation(); e.preventDefault(); setOpen((v) => !v); }}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onBlur={() => setOpen(false)}
        className="text-muted-foreground/70 hover:text-foreground transition-colors"
      >
        <Info className="w-3.5 h-3.5" />
      </button>
      {open && (
        <span
          role="tooltip"
          className="absolute left-1/2 -translate-x-1/2 top-full mt-2 z-50 w-56 max-w-[70vw] border border-border bg-background shadow-lg p-3 text-[11px] leading-snug text-foreground normal-case tracking-normal font-normal text-left"
        >
          {label && <span className="block font-bold mb-1">{label}</span>}
          {text}
        </span>
      )}
    </span>
  );
}
